import * as React from "react";
import { Box, Text, SkeletonText } from "@chakra-ui/react";

import { useDetailState } from "scenes/OfferDetail";
import { IMarginProps } from "src/types/types";

const Description: React.FC<IMarginProps> = ({ ...margins }) => {
  const { offer, isLoaded } = useDetailState();

  if (!offer?.description) {
    return null;
  }

  return (
    <SkeletonText isLoaded={isLoaded} noOfLines={7}>
      <Box {...margins}>
        <Text
          data-test="offerDetail.description"
          lineHeight="20px"
          wordBreak="break-word"
          dangerouslySetInnerHTML={{
            __html: offer
              ? offer.description
                  .replace(/(\r\n|\n\r|\n)/g, "<br/>")
                  .replace(/_____________/g, "<br /> <br />")
              : "",
          }}
        />
      </Box>
    </SkeletonText>
  );
};

export default Description;
